import React from "react";
import { SectionShell, Field, CheckboxGroup } from "./PartnerFormPrimitives";
import { SERVICE_AREAS } from "./partnerConstants";
import { toggleInArray } from "./partnerHelpers";

export default function PartnerServiceAreas({ data, setRaw }) {
  const toggle = (val) => setRaw("service_areas_covered", toggleInArray(data.service_areas_covered, val));
  return (
    <SectionShell
      index={2}
      title="Service Areas & Travel"
      subtitle="Where you work and how far you'll travel."
      testId="partner-section-areas"
    >
      <Field label="Service Areas Covered" required hint="Select all that apply">
        <CheckboxGroup
          options={SERVICE_AREAS}
          value={data.service_areas_covered}
          onChange={toggle}
          columns={3}
          testIdPrefix="partner-area"
        />
      </Field>

      {data.service_areas_covered.includes("Other") && (
        <Field label="Other Service Areas">
          <input className="input-br" value={data.service_areas_other} onChange={(e) => setRaw("service_areas_other", e.target.value)} placeholder="List other regions..." />
        </Field>
      )}

      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Maximum Travel Radius (miles)" required>
          <input type="number" min="0" className="input-br" value={data.max_travel_radius_miles} onChange={(e) => setRaw("max_travel_radius_miles", e.target.value)} required />
        </Field>
        <Field label="Travel Limitations or Preferences">
          <input className="input-br" value={data.travel_limitations} onChange={(e) => setRaw("travel_limitations", e.target.value)} placeholder="e.g. no overnight travel" />
        </Field>
      </div>
    </SectionShell>
  );
}
